<div class="w-full aligner-start h-[45px]" *ngIf="state.valueAsSingle">
  <div *ngIf="state.valueAsSingle === TriggeredByType.User" class="trigger-circle user">
    <y42-user-avatar [user]="state.triggeredByUser" [size]="IconSizePx"> </y42-user-avatar>
  </div>

  <div
    *ngIf="state.valueAsSingle === TriggeredByType.Orchestration"
    matTooltipPosition="above"
    matTooltip="Orchestration"
    class="trigger-circle hook"
  >
    <img [src]="OrchestrationIcon" [attr.width]="IconSizePx" alt="Orchestration icon" />
  </div>
</div>

<div class="w-full h-full aligner-start group-by-display" *ngIf="state.valueAsArray">
  <div *ngFor="let val of state.valueAsArray; trackBy: trackByType" class="mr-2 aligner-start">
    <div
      *ngIf="val.type === TriggeredByType.User"
      class="trigger-circle user"
      matTooltipPosition="above"
      matTooltip="User"
    >
      <fa-icon class="fs-07" [icon]="['fal', 'user']"></fa-icon>
    </div>

    <div
      *ngIf="val.type === TriggeredByType.Orchestration"
      matTooltipPosition="above"
      matTooltip="Orchestration"
      class="trigger-circle hook"
    >
      <img [src]="OrchestrationIcon" [attr.width]="IconSizePx" alt="Orchestration icon" />
    </div>
    <div class="font-normal ml-1 fs-07">
      {{ val.count }}
    </div>
  </div>
</div>
